var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_html.js
// module id = HDWL
// module chunks = 1